<template lang="html">
  <div style="padding:5px">{{item.description}}</div>
</template>

<script>
export default {
  props: {
    item: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// src/componentes/global/autocomplete/don.item.vue